<app-artwork-detail *ngIf="selection === 'artwork'" [artworkId]="artworkId"></app-artwork-detail>
<app-artwork-overview (yearSelection)="onYearSelection($event)" *ngIf="selection === 'overview'"></app-artwork-overview>
<app-artwork-list (artworkSelection)="onArtworkSelection($event)" *ngIf="selection === 'year'"
                  [year]="yearSelection"></app-artwork-list>
